import {Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit} from '@angular/core';
import {SongsService, AuthService} from '../../api/';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {ScrollService, ScrollParams, SearchService, BasicSearchParams} from '../../api';
import * as _ from 'lodash';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import { PlayerService } from '../../player/services/player.service';
import { MdDialogRef} from '@angular/material';
import {SongDetailComponent} from '../';
import { Globals } from '../../app.globals';
declare var $: any;

@Component({
  selector: 'app-songs-search-on-credits',
  templateUrl: './songs-search-on-credits.component.html',
  styleUrls: ['./songs-search-on-credits.component.css']
})
export class SongsSearchOnCreditsComponent implements OnInit {
  private type: string = '';
  private type3: string = '';
  private type2: string = '';
  private originalType: string = '';
  private typeTemp: string = '';
  private islocation: any = false;
  private iswriter: boolean = false;
  private ispublisher: boolean = false;
  private islabel: boolean = false;
  private value1: string = '';
  private title: string = '';
  private searchPlaceholder = 'Search ';
  private songs: Array<any>;
  private songs1: Array<any>;
  private songsTemper: Array<any>;
  private songsTemp: Array<any>;
  private scrollParams = new ScrollParams();
  private searchTerm: string = '';
  private lastTerm: string = '';
  private scrollSubscriber = null;
  private songsTemp2: any = false;
  private songsTemp3: any = false;
  private currentSongId: string = '';
  private loading: boolean = true;
  private totalRecords: number = 0; // for search see all count
  private viewAsList = 1;
  private sortedColumn = null;
  private limit: number = 30;
  private lyricSlice: number = 400;
  @BlockUI() blockUI: NgBlockUI;
  public slideIndex = 1;
  public interval = 0;
  song: any;
  private readMore: boolean = false;
  private readMore2: boolean = false;
  public creditsArray: any = [];
  public writersArray: any = [];
  private foundPlayedsong: boolean = false;
  dialogRef: MdDialogRef<SongDetailComponent>;
  public apiUrl: string = new Globals().apiEndpoint;
  private columnArr = [
    {title: 'C', key: 'album', type: 'image', width: '120px', isSortable: true, responsiveIndex: 'all'},
    {
      title: 'Artist',
      key: 'artist.name',
      type: 'anchor',
      width: '220px',
      textStyle: ['my-music-artist'],
      responsiveIndex: 'gt-md'
    },
    {
      title: 'Name',
      key: 'name',
      type: 'anchor',
      width: '350px',
      textStyle: ['my-music-name'],
      responsiveIndex: 'all'
    },
    {title: 'Genres', key: 'genre', type: 'genre', width: '', responsiveIndex: 'sm'},
  ];

  constructor(private authService: AuthService,private playerService: PlayerService, private songsService: SongsService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef,
  private scrollService: ScrollService, private router: Router, private searchService: SearchService) {
    localStorage.setItem("radio",'0');
    this.songs = new Array<any>();
    if (screen.width <= 668) {
      this.lyricSlice = 400;
    }else if (screen.width <= 1400) {
      this.lyricSlice = 450;
    }else if (screen.width <= 3070) {
      this.lyricSlice = 550;
    }else{
      this.lyricSlice = 700;
    }
    this.songsTemp2 = false;
    this.songsTemp3 = false;
    this.viewAsList = 1;
  }

  ngOnInit() {
    this.scrollService.enableScrollIfDisabled();
    this.totalRecords = 0;
    this.currentSongId = this.playerService.getCurrentTrack();
    this.route.queryParams.subscribe((queryParams: any) => {
      this.searchTerm = queryParams.q;

      this.ispublisher = queryParams.ispublisher;
      this.iswriter = queryParams.iswriter;
      this.islabel = queryParams.islabel;

      this.value1 = queryParams.namee;
      this.value1 = this.value1.charAt(0).toUpperCase() + this.value1.slice(1);;

      this.type2 = queryParams.type;
      this.originalType = queryParams.type;
      if(this.islabel){
        this.type2 = "Label";
        this.typeTemp = this.type2;
      }else if(this.iswriter){
        this.type2 = "Written by";
        this.typeTemp = this.type2;
      }else if(this.ispublisher){
        this.type2 = "Published by";
        this.typeTemp = this.type2;
      }else {
        this.type2 = queryParams.type;
        this.type2 = this.type2.replace("_", " ");
        this.type2 = this.type2.charAt(0).toUpperCase() + this.type2.slice(1);
        this.islocation = queryParams.islocation;
      }
      if(this.islocation == "true"){
        this.typeTemp  = this.type2.replace("at", "in");
      }else if(this.islocation == "false"){
        if(!(this.type2.includes("by")) && !(this.type2.includes("at"))){
          this.type2 = this.type2 + " by" ;
        }
        this.typeTemp = this.type2;
      }
      this.typeTemp = this.typeTemp.charAt(0).toUpperCase() + this.typeTemp.slice(1);
      this.title = this.typeTemp + " " + this.value1 ;
      this.songs = new Array<any>();
      this.songsTemp2 = false;
      this.resetScrollParams();
      this.getSongsByType();
    });
    this.songsTemper = new Array<any>();
    if (localStorage.getItem("viewAsList") == "1") {
      this.viewAsList = 1;
    }
    if (localStorage.getItem("viewAsList") == "2") {
      this.viewAsList = 2;
    }
    if (localStorage.getItem("viewAsList") == "3") {
      this.viewAsList = 3;
    }
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getSongsByType());
    this.songsTemp = this.songs;
  }

  mouseHovering(index) {
    this.songs[index].isHovering = true;
  }

  mouseLeaving(index) {
    this.songs[index].isHovering = false;
  }

  getSongsByType() {
    this.scrollService.enableScrollIfDisabled();
    if(this.searchTerm != "") {
      if (this.lastTerm !== this.searchTerm) {
        this.resetScrollParams();
        this.lastTerm = this.searchTerm;
        this.songs = new Array<any>();
      }
      this.type = 'NM';
        if (this.type === 'NM') {
        this.blockUI.start('Loading, please wait...');
        this.getMusicLibrary();
      }
      if (this.type === 'credits') {
        this.blockUI.start('Loading, please wait...');
        let params = new BasicSearchParams(true, false, false);
        this.searchService.getSearchResults(this.searchTerm, params, this.scrollParams).then((res: any) => {
          this.totalRecords = res.total;
          let songs = this.searchService.fetchIds(res.data.song);
          return this.songsService.getSongsById(songs).toPromise();
        }).then((res: any) => {
          if (res.length > 0) {
            res.forEach((arrayItem) => {
              if (arrayItem.lyrics != null) {
                arrayItem.songLyrics = arrayItem.lyrics;
                arrayItem.songLyrics2 = arrayItem.songLyrics.slice(0, this.lyricSlice);
              }
              this.songs.push(arrayItem);
            });
            this.scrollParams.page++;
            this.songs = _.uniqBy(this.songs, 'id');
          }
          this.blockUI.stop();
          this.cdRef.detectChanges();
        }).catch((err) => {
        });
      } else if (this.type === 'search') {
        this.blockUI.start('Loading, please wait...');
        let params = new BasicSearchParams(true, false, false);
        this.searchService.getSearchResults(this.searchTerm, params, this.scrollParams).then((res: any) => {
          this.totalRecords = res.total;
          if(res.total > 0){
            if(res.data.song.length > 0){
              res.data.song.forEach((arrayItem) => {
                if (arrayItem._source.lyrics != null && arrayItem._source.lyrics != "") {
                  arrayItem._source.songLyrics = arrayItem._source.lyrics;
                  arrayItem._source.songLyrics2 = arrayItem._source.songLyrics.slice(0, this.lyricSlice);
                }
                if(arrayItem._source.genres && arrayItem._source.genres.name){
                  arrayItem._source.genre = arrayItem._source.genres.name;
                }else{
                  arrayItem._source.genre = "";
                }
                arrayItem._source._type = "song"
                arrayItem._source.active = 1;
                this.songs.push(arrayItem._source);
              });
              this.scrollParams.page++;
              this.songs = _.uniqBy(this.songs, 'id');
            }
          }
          this.blockUI.stop();
          this.cdRef.detectChanges();
        })
        .catch((err) => {
        });
      }
    } else {
      this.songs = new Array<any>();
    }
  }

  getMusicLibrary() {
    if(this.songs.length == 0){
      this.viewAsList = 1;
      localStorage.setItem("viewAsList", "1");
    }
    this.route.queryParams.subscribe((queryParams: any) => {
      this.searchTerm = queryParams.q;

      this.ispublisher = queryParams.ispublisher;
      this.iswriter = queryParams.iswriter;
      this.islabel = queryParams.islabel;

      this.value1 = queryParams.namee;
      this.value1 = this.value1.charAt(0).toUpperCase() + this.value1.slice(1);;

      this.type2 = queryParams.type;
      this.originalType = queryParams.type;

      if(this.islabel){
        this.type2 = "Label";
        this.typeTemp = this.type2;
      }else if(this.iswriter){
        this.type2 = "Written by";
        this.typeTemp = this.type2;
      }else if(this.ispublisher){
        this.type2 = "Published by";
        this.typeTemp = this.type2;
      }else {
        this.type2 = queryParams.type;
        this.type2 = this.type2.replace("_", " ");
        this.type2 = this.type2.charAt(0).toUpperCase() + this.type2.slice(1);
        this.islocation = queryParams.islocation;

      }
      if(this.islocation == "true"){
        this.typeTemp  = this.type2.replace("at", "in");
      }else if(this.islocation == "false"){
        if(!(this.type2.includes("by")) && !(this.type2.includes("at"))){
          this.type2 = this.type2 + " by" ;
        }
        this.typeTemp = this.type2;
      }
      this.typeTemp = this.typeTemp.charAt(0).toUpperCase() + this.typeTemp.slice(1);
      this.title = this.typeTemp + " " + this.value1 ;
    });

    if(this.iswriter || this.ispublisher || this.islabel) {
      if(!this.islabel){
        this.islabel = false;
      }else if(!this.iswriter || this.iswriter == null){
        this.iswriter = false;
      }else if(!this.ispublisher){
        this.ispublisher = false;
      }
      if(!this.songsTemp2){
        if(!this.songsTemp3){
          this.scrollService.toggleProgressBar(true);
        }
        let queryParams = '';
        queryParams += 'page=' + this.scrollParams.page;
        if (this.sortedColumn && this.sortedColumn.key) {
          queryParams += '&sortBy=' + this.sortedColumn.key + '&sortOrder=' + this.sortedColumn.sortOrder;
        }
        if(this.value1!=''){
          queryParams += '&name=' + this.value1;
        }
        var that = this;
        queryParams += '&iswriter=' + this.iswriter;
        queryParams += '&ispublisher=' + this.ispublisher;
        queryParams += '&islabel=' + this.islabel;
        $.get(this.apiUrl+"songs/songsss?" + queryParams).done(
          (res) => {
            that.commonFunc(res);
          }).fail((res)=>{
            that.scrollService.toggleProgressBar(false);
            that.loading = false;
            that.blockUI.stop();
          });
      } else {
        let x = document.getElementById("noRecord");
        if(x){
          x.setAttribute("style", "display:block;");
        }
        this.blockUI.stop();
      }
    } else {
      if(!this.songsTemp2) {
        if(!this.songsTemp3){
          this.blockUI.start('Loading, please wait...');
          this.scrollService.toggleProgressBar(true);
        }
        this.songsService.getAllSongs(this.scrollParams.page, this.sortedColumn,this.value1,this.originalType,this.islocation)
        .toPromise().then((res) => {
          this.commonFunc(res);
        }).catch((err) => {
          this.scrollService.toggleProgressBar(false);
          this.loading = false;
          this.blockUI.stop();
        });
      }else{
        let x = document.getElementById("noRecord");
        if(x){
          x.setAttribute("style", "display:block;");
        }
        this.blockUI.stop();
      }
    }
    this.currentSongId = this.playerService.getCurrentTrack();
    setTimeout(()=>{
      if(this.currentSongId != null){
        this.showDivs(this.currentSongId)
      }
    },4000);
    this.type3 = "";
  }

  commonFunc(res) {
    this.totalRecords = res.total;
    res.songs.forEach((arrayItem) => {
      if(arrayItem != null) {
        if (arrayItem.lyrics != null) {
          arrayItem.songLyrics = arrayItem.lyrics;
          arrayItem.songLyrics2 = arrayItem.songLyrics.slice(0, this.lyricSlice);
        }
        this.songs.push(arrayItem);
      }
    });
    this.scrollParams.page++;
    this.songs = _.uniqBy(this.songs, 'id');
    this.scrollService.toggleProgressBar(false);
    this.loading = false;
    this.cdRef.detectChanges();
    if(res.songs.length == 0) {
      this.songsTemp2 = true;
      this.songsTemp3 = true;
    }
    this.blockUI.stop();
  }

  removeFromQue(){
    let x = document.getElementById("noRecord");
    x.setAttribute("style", "display:none;");
  }

  showDivs(n) {
    let i;
    // grid view scroll function
    let x = document.getElementsByClassName("mySlides");
    if (x.length > 0) {
      for (i = 0; i < x.length; i++) {
        if(x[i]) {
          x[i].setAttribute("style", "display:none;");
        }
      }
      if(document.getElementById("song"+n)) {
        document.getElementById("song"+n).setAttribute("style", "display:block;")
      } else{
       if(x[0]){
         x[0].setAttribute("style", "display:block;")
       }
     }
    }
    let y = document.getElementsByClassName("grid1");
    if (y.length > 0) {
      for (i = 0; i < y.length; i++) {
       if(y[i]){
        y[i].setAttribute("style", "opacity: 0;");
       }
      }
      let sc = document.getElementById("gridsong"+n);
      if(sc){
        sc.scrollIntoView();
      }
      let grid1 = document.getElementById("grid1"+n);
      if(grid1) {
        grid1.setAttribute("style", "opacity: 0.8 !important;");
      }
    }
  }

  sortColumn(event, type) {
    this.blockUI.start('Loading, please wait...');
    this.sortedColumn = event;
    this.scrollParams = new ScrollParams();
    this.songs = new Array<any>();
    this.getMusicLibrary();
  }

  toggleViewAsList(value) {
    this.viewAsList = value;
    localStorage.setItem("viewAsList", value);
    if (this.viewAsList == 3) {
      if (document.getElementById('Ui123456') != null) {
        document.getElementById('Ui123456').className = 'app-content2';
      }
      if (document.getElementById('Ui12345') != null) {
        document.getElementById('Ui12345').className = 'app-content2';
      }
    }
    if(this.viewAsList != 3) {
      if (document.getElementById('Ui123456') != null) {
        document.getElementById('Ui123456').className = 'app-content';
      }
      if (document.getElementById('Ui12345') != null) {
        document.getElementById('Ui12345').className = 'app-content';
      }
    }
  }

  handleSearchs(event) {
    this.searchTerm = event.searchTerm;
    let navigationExtras: NavigationExtras = {
      relativeTo: this.route,
      queryParams: { 'q': this.searchTerm },
    };
    this.getSongsByType();
    this.router.navigate([], navigationExtras);
  }

  handleSearch(event) {
    this.searchTerm = event.searchTerm;
    let navigationExtras: NavigationExtras = {
      relativeTo: this.route,
      queryParams: {'q': this.searchTerm},
    };
    if (this.songsTemp) {
      if (this.route.snapshot.data['type'] == "NM") {
        this.blockUI.start('Loading, please wait...');
      }
      this.songs = new Array<any>();
      if (this.searchTerm != "") {
        for (var i = 0; i < this.songsTemp.length; i++) {
          var namee, artistt, genree = "";
          namee = this.songsTemp[i].name.toUpperCase();
          artistt = this.songsTemp[i].artist.name.toUpperCase();
          this.songsTemp[i].genres.forEach(element => {
            genree += element.name.toUpperCase() + ",";
          });
          if (namee.indexOf(this.searchTerm.toUpperCase()) > -1) {
            this.songs.push(this.songsTemp[i]);
          }
          if (artistt.indexOf(this.searchTerm.toUpperCase()) > -1) {
            this.songs.push(this.songsTemp[i]);
          }
          if (genree.indexOf(this.searchTerm.toUpperCase()) > -1) {
            this.songs.push(this.songsTemp[i]);
          }
        }
        this.songs = _.uniqBy(this.songs, 'id');
      } else {
        this.songs = this.songsTemp;
      }
    }
    if (this.route.snapshot.data['type'] == "NM") {
      setTimeout(() => {
        this.blockUI.stop();
      }, 3000);
    }
  }

  resetScrollParams() {
    this.scrollParams = new ScrollParams();
  }

  ngOnDestroy() {
    if (this.scrollSubscriber != null) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  refreshList(){
    this.getSongsByType();
  }

  refreshList2(){
    this.blockUI.start('Loading, please wait...');
    this.scrollParams.page = 1;
    this.type3 = "CS";
    this.songs.length = 0;
    setTimeout(() => {
      this.getMusicLibrary();
    }, 3000);
  }

}



// WEBPACK FOOTER //
// ./src/app/songs/songs-search-on-credits/songs-search-on-credits.component.ts